@if (session(); as portalSession) {
  @if (portalSession.uiExperience === 'classic') {
    <div class="classic-shell" data-experience="classic">
      <header class="classic-topbar">
        <button type="button" class="classic-apps" (click)="openCommandMenu()"><i class="fa-solid fa-grip" aria-hidden="true"></i><span>Applications</span></button>
        <a class="classic-brand" routerLink="/dashboard"><img src="/logilink_logo_color.png" alt="LogiLink"><strong>LOGILINK</strong></a>
        <span class="classic-divider" aria-hidden="true"></span><strong class="classic-title">{{ currentPageTitle() }}</strong>
        <span class="classic-spacer"></span><span class="classic-workspace">{{ workspaceName() }}</span>
        <a class="topbar-icon-button" routerLink="/help" aria-label="Help"><i class="fa-regular fa-circle-question" aria-hidden="true"></i></a>
        <button class="topbar-icon-button" type="button" aria-label="Sign out" (click)="logout()"><i class="fa-solid fa-arrow-right-from-bracket" aria-hidden="true"></i></button>
      </header>
      <main class="classic-content"><router-outlet></router-outlet></main>
    </div>
  } @else {
  <div class="portal-shell" [class.sidebar-collapsed]="sidebarCollapsed()" data-experience="revamped">
    <aside class="portal-sidebar" [class.mobile-visible]="mobileNavigationVisible()" aria-label="Primary navigation">
      <div class="sidebar-brand-row">
        <a class="sidebar-brand" routerLink="/dashboard" aria-label="LogiLink overview">
          <span class="brand-mark"><img src="/logilink_logo_color.png" alt=""></span>
          <span class="brand-copy"><strong>LOGILINK</strong><small>Customer portal</small></span>
        </a>
        <button class="sidebar-icon-button desktop-collapse" type="button"
          [attr.aria-label]="sidebarCollapsed() ? 'Expand navigation' : 'Collapse navigation'"
          [attr.aria-expanded]="!sidebarCollapsed()" (click)="toggleSidebar()">
          <i [class]="sidebarCollapsed() ? 'fa-solid fa-angles-right' : 'fa-solid fa-angles-left'" aria-hidden="true"></i>
        </button>
        <button class="sidebar-icon-button mobile-close" type="button" aria-label="Close navigation" (click)="closeOverlays()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </div>

      <div class="sidebar-workspace" [attr.title]="workspaceName()">
        @if (portalSession.scope.crmClientLogoUrl && !clientLogoFailed()) {
          <img [src]="portalSession.scope.crmClientLogoUrl" alt="" (error)="clientLogoFailed.set(true)">
        } @else {
          <span class="workspace-initial">{{ clientInitial() }}</span>
        }
        <span class="workspace-copy"><small>Workspace</small><strong>{{ workspaceName() }}</strong></span>
      </div>

      <nav class="sidebar-navigation">
        @for (group of navGroups(); track group.key) {
          <section class="nav-group" [attr.aria-labelledby]="'nav-' + group.key">
            <h2 [id]="'nav-' + group.key">{{ group.label }}</h2>
            @for (item of group.items; track item.key) {
              <a class="nav-link" [class.active]="isActive(item)" [routerLink]="item.route"
                [attr.title]="sidebarCollapsed() ? item.label : null" (click)="closeOverlays()">
                <span [class]="'nav-icon ' + item.accent"><i [class]="item.icon" aria-hidden="true"></i></span>
                <span class="nav-copy"><strong>{{ item.label }}</strong><small>{{ item.description }}</small></span>
              </a>
            }
          </section>
        }
      </nav>

      <div class="sidebar-footer">
        <button type="button" class="command-trigger" (click)="openCommandMenu()" title="Open command palette">
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
          <span>Find a workspace</span><kbd>Ctrl K</kbd>
        </button>
      </div>
    </aside>

    @if (mobileNavigationVisible()) {
      <button class="mobile-backdrop" type="button" aria-label="Close navigation" (click)="closeOverlays()"></button>
    }

    <div class="portal-main">
      <header class="portal-topbar">
        <div class="topbar-context">
          <button class="topbar-icon-button mobile-menu" type="button" aria-label="Open navigation" (click)="toggleMobileNavigation()">
            <i class="fa-solid fa-bars" aria-hidden="true"></i>
          </button>
          <div><small>{{ workspaceName() }}</small><strong>{{ currentPageTitle() }}</strong></div>
        </div>

        <div class="topbar-actions">
          <button class="topbar-search" type="button" (click)="openCommandMenu()">
            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i><span>Find a workspace</span><kbd>Ctrl K</kbd>
          </button>
          <a class="topbar-icon-button" routerLink="/help" aria-label="Open help" title="Help">
            <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
          </a>
          <div class="profile-chip" [attr.aria-label]="'Signed in as ' + (portalSession.profile.name || portalSession.profile.emailAddress)">
            @if (portalSession.profile.imageUrl) {
              <img [src]="portalSession.profile.imageUrl" alt="">
            } @else {
              <span class="profile-avatar">{{ userInitial() }}</span>
            }
            <span><strong>{{ portalSession.profile.name || portalSession.profile.emailAddress }}</strong><small>{{ primaryRoleLabel() }}</small></span>
          </div>
          <button class="topbar-icon-button" type="button" aria-label="Sign out" title="Sign out" (click)="logout()">
            <i class="fa-solid fa-arrow-right-from-bracket" aria-hidden="true"></i>
          </button>
        </div>
      </header>

      <main class="portal-content">
        <div class="content-frame"><router-outlet></router-outlet></div>
      </main>
    </div>
  </div>
  }

  @if (commandMenuVisible()) {
    <button class="command-backdrop" type="button" aria-label="Close workspace finder" (click)="closeOverlays()"></button>
    <section class="command-palette" role="dialog" aria-modal="true" aria-labelledby="command-title">
      <header class="command-header">
        <div><span class="command-eyebrow">Customer workspace</span><h2 id="command-title">Where would you like to go?</h2></div>
        <button type="button" class="palette-close" aria-label="Close workspace finder" (click)="closeOverlays()"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
      </header>
      <label class="command-search">
        <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
        <input #applicationSearch type="search" autofocus [value]="applicationSearchTerm()"
          (input)="onApplicationSearchChange(applicationSearch.value)" placeholder="Search shipments, finance, support…" aria-label="Search workspaces">
        @if (applicationSearchTerm()) {
          <button type="button" aria-label="Clear search" (click)="clearApplicationSearch()"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
        }
      </label>
      <nav class="command-grid" aria-label="Available workspaces">
        @for (item of visibleLauncherItems(); track item.key) {
          <a class="command-card" [class.active]="isActive(item)" [routerLink]="item.route" (click)="closeOverlays()">
            <span [class]="'command-icon ' + item.accent"><i [class]="item.icon" aria-hidden="true"></i></span>
            <span><small>{{ item.group }}</small><strong>{{ item.label }}</strong><span>{{ item.description }}</span></span>
            <i class="fa-solid fa-arrow-right command-arrow" aria-hidden="true"></i>
          </a>
        } @empty {
          <div class="command-empty"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i><strong>No matching workspace</strong><span>Try a shorter search or clear the field.</span></div>
        }
      </nav>
      <footer class="command-footer"><span>{{ visibleLauncherItems().length }} workspaces available to your account</span><span>Press <kbd>Esc</kbd> to close</span></footer>
    </section>
  }
} @else {
  <router-outlet></router-outlet>
}
